export default function RemplacementMoteur() {
  return (
    <section className="bg-brand-light py-14 md:py-20">
      <div className="max-w-4xl mx-auto px-4 md:px-8">
        <h2 className="text-2xl md:text-3xl font-bold text-brand-blue mb-6">
          Remplacement du moteur Bubendorff étape par étape
        </h2>
        <p className="text-brand-text leading-relaxed mb-5">
          Le remplacement d&apos;un moteur Bubendorff exige une méthodologie rigoureuse car la motorisation est intégrée au tablier. Notre intervention commence par une phase de diagnostic complète : le technicien démonte le coffre du volet, extrait le tablier avec précaution et isole le moteur. Contrairement à un moteur tubulaire standard, le moteur Bubendorff est fixé directement dans la structure du tablier, ce qui impose un démontage méthodique pour ne pas endommager les lames ou les glissières.
        </p>
        <p className="text-brand-text leading-relaxed mb-8">
          Une fois le moteur déposé, nous procédons au recâblage ou à la reconfiguration de la liaison radio. Si le modèle est équipé de batteries solaires, nous remplaçons l&apos;ensemble batterie + panneau photovoltaïque en même temps que le moteur pour garantir une alimentation fiable. Le nouveau moteur est ensuite programmé avec la télécommande existante, ou nous configurons une nouvelle télécommande Bubendorff si l&apos;ancienne est trop vieille. La fin de course est réglée avec précision pour éviter tout blocage ou débordement. Enfin, le tablier est réinstallé dans le coffre et le technicien effectue une série de tests de montée, descente et arrêt d&apos;urgence avant de vous remettre le volet en service.
        </p>

        <h3 className="text-xl font-semibold text-brand-blue mb-4">
          Déroulement de l&apos;intervention
        </h3>
        <ul className="space-y-3">
          {[
            "Diagnostic complet du moteur, de la radio et des batteries solaires",
            "Dépose soignée du tablier et accès au moteur intégré Bubendorff",
            "Retrait du moteur défectueux et nettoyage du logement",
            "Pose du nouveau moteur avec fixation adaptée au tablier",
            "Recâblage ou appairage radio avec les télécommandes existantes",
            "Réglage des fins de course et tests de montée / descente complets",
          ].map((item) => (
            <li key={item} className="flex items-start gap-3">
              <span className="w-5 h-5 flex items-center justify-center text-brand-cyan mt-0.5 flex-shrink-0">
                <i className="ri-checkbox-circle-line text-lg"></i>
              </span>
              <span className="text-brand-text text-sm md:text-base">{item}</span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}